import { render, staticRenderFns } from "./FactorInitiativesDrawer.vue?vue&type=template&id=6a4ef47c"
import script from "./FactorInitiativesDrawer.vue?vue&type=script&lang=js"
export * from "./FactorInitiativesDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports